(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atlas-collections"]) return;
  try {
    
  const root = document.querySelector('.ac');
  if (root && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    root.querySelectorAll('.ac-reveal').forEach((el) => io.observe(el));
  } else if (root) {
    root.querySelectorAll('.ac-reveal').forEach((el) => el.classList.add('is-visible'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atlas-cubiertas"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STORE_KEY = 'atlas_pickup';
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  var esc = function (s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  /* ---------- Dibujo de la pickup y las cubiertas (sistema 1000×340) ---------- */
  var TRUCK = "M60,270 L60,182 C60,176 64,172 70,172 L432,170 L446,168 L474,104 C478,96 484,92 494,92 L626,90 C636,90 644,94 650,100 L712,160 C716,164 722,166 728,166 L886,178 C912,180 932,192 938,212 L942,262 L832,268 A60,60 0 0 0 712,268 L310,268 A60,60 0 0 0 190,268 Z";
  var GLASS = "M462,166 L488,110 C490,106 494,104 498,104 L620,102 C626,102 630,104 634,108 L690,164 Z";
  var EDGE = 'stroke="#fff" stroke-opacity=".28" stroke-width="1"';

  function truck(theme) {
    var dark = theme !== 'light';
    return '<ellipse cx="500" cy="296" rx="460" ry="14" fill="' + (dark ? '#2f66ff' : '#000') + '" opacity="' + (dark ? '.16' : '.12') + '" filter="url(#fSoft)"/>' +
      '<path d="' + TRUCK + '" fill="url(#' + (dark ? 'gCar' : 'gCarL') + ')"/>' +
      '<path d="' + GLASS + '" fill="#000" opacity=".8"/>' +
      '<path d="' + TRUCK + '" fill="none" stroke="' + (dark ? 'url(#gRim)' : 'rgba(255,255,255,.25)') + '" stroke-width="1.5"/>' +
      '<path d="M60,186 L432,184 M455,172 L455,262 M566,104 L566,166 M566,170 L570,262" fill="none" stroke="#fff" stroke-opacity=".13"/>' +
      '<path d="M902,190 L934,197" stroke="#9db6ff" stroke-opacity=".8" stroke-width="3" stroke-linecap="round"/>' +
      '<rect x="61" y="186" width="5" height="24" rx="2" fill="#ff3b30" opacity=".55"/>' +
      '<circle cx="250" cy="280" r="50" fill="#050506" stroke="#26282d"/><circle cx="250" cy="280" r="26" fill="none" stroke="#1d1e22" stroke-width="3"/>' +
      '<circle cx="772" cy="280" r="50" fill="#050506" stroke="#26282d"/><circle cx="772" cy="280" r="26" fill="none" stroke="#1d1e22" stroke-width="3"/>';
  }

  function cover(type, cls) {
    cls = cls || '';
    if (type === 'fold') return '<g class="cv cv-fold ' + cls + '">' +
        '<rect class="p3" x="310" y="163" width="122" height="9" rx="2" fill="url(#gSoft)" ' + EDGE + '/>' +
        '<rect class="p2" x="188" y="163" width="122" height="9" rx="2" fill="url(#gSoft)" ' + EDGE + '/>' +
        '<rect class="p1" x="66" y="163" width="122" height="9" rx="2" fill="url(#gSoft)" ' + EDGE + '/></g>';
    if (type === 'hard') return '<g class="cv cv-fold ' + cls + '">' +
        '<rect class="p3" x="310" y="161" width="122" height="11" rx="2" fill="url(#gAlu)" ' + EDGE + '/>' +
        '<rect class="p2" x="188" y="161" width="122" height="11" rx="2" fill="url(#gAlu)" ' + EDGE + '/>' +
        '<rect class="p1" x="66" y="161" width="122" height="11" rx="2" fill="url(#gAlu)" ' + EDGE + '/></g>';
    if (type === 'elec') return cover('retr', cls).replace('cv cv-retr', 'cv cv-retr cv-elec').replace(/<\/g>\s*$/,
        '<circle class="led" cx="424" cy="164" r="7" fill="#2f66ff" opacity=".35" filter="url(#fGlow)"/><circle class="led" cx="424" cy="164" r="2.6" fill="#8fb0ff"/></g>');
    if (type === 'retr') {
      var slats = '';
      for (var i = 0; i < 22; i++) slats += '<path d="M' + (80 + i * 15.5) + ',164 V171" stroke="#000" stroke-opacity=".35"/>';
      return '<g class="cv cv-retr ' + cls + '"><g class="skin">' +
        '<rect x="64" y="163" width="352" height="9" rx="1.5" fill="url(#gAlu)" ' + EDGE + '/>' + slats + '</g>' +
        '<rect x="414" y="155" width="20" height="18" rx="3" fill="url(#gAlu)" ' + EDGE + '/></g>';
    }
    return '';
  }

  function scene(type, theme) {
    return '<g transform="translate(0,40)">' + truck(theme) + cover(type) + '</g>';
  }

  /* Vista superior (tarjetas sin foto): la cubierta se ve completa */
  function topView(type) {
    var bed = { x: 58, y: 84, w: 300, h: 152 };
    var skin = '';
    var i;
    if (type === 'fold' || type === 'hard') {
      var fill = type === 'hard' ? 'url(#tAlu)' : 'url(#tSoft)';
      for (i = 0; i < 3; i++) skin += '<rect x="' + (bed.x + i * (bed.w / 3) + (i ? 2 : 0)) + '" y="' + bed.y + '" width="' + (bed.w / 3 - 2) + '" height="' + bed.h + '" rx="5" fill="' + fill + '"/>';
      if (type === 'hard') skin += '<rect x="' + (bed.x + 6) + '" y="' + (bed.y + bed.h / 2 - 14) + '" width="5" height="28" rx="2" fill="#0b0b0d" opacity=".7"/>';
    } else if (type === 'retr' || type === 'elec') {
      skin = '<rect x="' + bed.x + '" y="' + bed.y + '" width="' + bed.w + '" height="' + bed.h + '" rx="5" fill="url(#tAlu)"/>';
      for (i = 0; i < 28; i++) skin += '<path d="M' + (bed.x + 8 + i * 10.2) + ',' + (bed.y + 2) + ' V' + (bed.y + bed.h - 2) + '" stroke="#000" stroke-opacity=".28"/>';
      skin += '<rect x="' + (bed.x + bed.w - 14) + '" y="' + (bed.y - 4) + '" width="18" height="' + (bed.h + 8) + '" rx="4" fill="#2a2c31"/>' +
        '<circle cx="' + (bed.x + 10) + '" cy="' + (bed.y + bed.h / 2) + '" r="3.5" fill="#0b0b0d"/>';
      if (type === 'elec') skin += '<circle cx="' + (bed.x + bed.w - 5) + '" cy="' + (bed.y + bed.h / 2) + '" r="8" fill="#2f66ff" opacity=".45" filter="url(#fGlow)"/><circle cx="' + (bed.x + bed.w - 5) + '" cy="' + (bed.y + bed.h / 2) + '" r="3" fill="#8fb0ff"/>';
    }
    return '<g>' +
      '<ellipse cx="275" cy="168" rx="250" ry="118" fill="#000" opacity=".16" filter="url(#fSoft)"/>' +
      '<rect x="44" y="70" width="460" height="180" rx="34" fill="url(#tBody)"/>' +
      '<rect x="44.5" y="70.5" width="459" height="179" rx="33.5" fill="none" stroke="#fff" stroke-opacity=".14"/>' +
      '<rect x="' + (bed.x - 4) + '" y="' + (bed.y - 4) + '" width="' + (bed.w + 8) + '" height="' + (bed.h + 8) + '" rx="8" fill="#060607"/>' +
      skin +
      '<rect x="372" y="86" width="104" height="148" rx="22" fill="#0b0b0d"/>' +
      '<rect x="462" y="96" width="30" height="128" rx="14" fill="#14161b"/>' +
      '<rect x="498" y="88" width="6" height="24" rx="3" fill="#9db6ff" opacity=".7"/><rect x="498" y="208" width="6" height="24" rx="3" fill="#9db6ff" opacity=".7"/>' +
      '<rect x="42" y="92" width="4" height="22" rx="2" fill="#ff3b30" opacity=".55"/><rect x="42" y="206" width="4" height="22" rx="2" fill="#ff3b30" opacity=".55"/>' +
      '<rect x="380" y="62" width="22" height="10" rx="3" fill="#1c1d21"/><rect x="380" y="248" width="22" height="10" rx="3" fill="#1c1d21"/>' +
      '</g>';
  }

  function init(root) {
    var one = function (s) { return root.querySelector(s); };
    var all = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var sel = one('[data-model]');
    var out = one('[data-finder-out]');
    var fitNote = one('[data-fit-note]');
    var empty = one('[data-empty]');
    var grid = one('[data-grid]');
    var cards = all('[data-card]');
    var tabs = all('[data-tab]');
    var panels = all('[data-panel]');
    var svg = one('[data-type-svg]');
    var stateEl = one('[data-type-state]');
    var dock = one('[data-dock]');
    var prodSec = one('[data-products]');
    var waNumber = root.getAttribute('data-wa-number');
    var model = store.get(STORE_KEY) || '';
    var filter = 'all';
    var cur = tabs.length ? tabs[0].getAttribute('data-tab') : '';
    var loop = null, t0 = null;

    /* Hero */
    one('[data-hero]').innerHTML = '<svg viewBox="0 0 1000 380"><g transform="translate(0,40)">' + truck('dark') +
      '<g class="cover-in">' + cover('hard') + '</g>' +
      '<circle cx="250" cy="166" r="12" fill="#2f66ff" opacity=".35" filter="url(#fGlow)"/><circle cx="250" cy="166" r="4.5" fill="#fff"/>' +
      '<path d="M250,166 L190,74" stroke="rgba(255,255,255,.28)"/></g></svg>' +
      '<div class="hero-tag" style="left:19%;top:12%"><span>Cubierta</span><b>' + esc(tabs.length ? tabs[0].textContent : '') + '</b></div>';
    requestAnimationFrame(function () { root.classList.add('loaded'); });

    /* Tipos con animación */
    function showType(id) {
      cur = id;
      tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t.getAttribute('data-tab') === id)); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== id; });
      var tab = tabs.filter(function (t) { return t.getAttribute('data-tab') === id; })[0];
      if (!tab || !svg) return;
      svg.innerHTML = scene(tab.getAttribute('data-anim'), 'dark');
      clearInterval(loop); clearTimeout(t0);
      var g = svg.querySelector('.cv');
      var toggle = function (open) { g.classList.toggle('open', open); stateEl.textContent = open ? 'Abierto' : 'Cerrado'; };
      toggle(false);
      if (reduce) return;
      var open = false;
      t0 = setTimeout(function () { open = true; toggle(true); }, 700);
      loop = setInterval(function () { open = !open; toggle(open); }, 2400);
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { showType(t.getAttribute('data-tab')); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        showType(tabs[n].getAttribute('data-tab')); tabs[n].focus();
      });
    });
    if (svg && tabs.length && 'IntersectionObserver' in window) {
      var typeIO = new IntersectionObserver(function (entries, o) {
        if (entries[0].isIntersecting) { showType(cur); o.disconnect(); }
      }, { threshold: 0.3 });
      typeIO.observe(svg);
    }

    /* Tarjetas: foto o ilustración, y filtros por tipo y modelo */
    cards.forEach(function (c) {
      var noimg = c.querySelector('[data-noimg]');
      if (noimg) noimg.innerHTML = topView(c.getAttribute('data-anim'));
    });

    function modelName() {
      var o = sel && sel.options[sel.selectedIndex];
      return o && o.value ? o.text : '';
    }
    function setFilter(f) {
      filter = f;
      all('[data-f]').forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-f') === f)); });
      render();
    }
    function render() {
      var known = model && model !== 'otra';
      var shown = 0;
      cards.forEach(function (c) {
        var fit = c.getAttribute('data-fit').split(' ').filter(Boolean);
        var fits = known ? fit.indexOf(model) !== -1 : true;
        var visible = (filter === 'all' || c.getAttribute('data-type') === filter) && fits;
        c.classList.toggle('hide', !visible);
        if (visible) shown++;
        var p = c.querySelector('.p-fit');
        p.className = 'p-fit' + (known ? ' yes' : '');
        p.querySelector('span').textContent = known ? 'Compatible con tu ' + modelName() : 'Para ' + fit.length + ' modelos de pickup';
      });
      if (known) {
        fitNote.innerHTML = 'Mostrando cubiertas para tu <b>' + esc(modelName()) + '</b>. <button type="button" data-clear-model>Ver todas</button>';
      } else if (model === 'otra') {
        fitNote.textContent = 'Tu pickup no está en la lista. Te mostramos todas y te ayudamos a confirmar cuál calza.';
      } else {
        fitNote.textContent = 'Elige tu pickup arriba y te mostramos solo las que calzan.';
      }
      if (empty) empty.classList.toggle('show', shown === 0);
    }
    function updateFinder() {
      var known = model && model !== 'otra';
      if (known) {
        var n = cards.filter(function (c) { return c.getAttribute('data-fit').split(' ').indexOf(model) !== -1; }).length;
        out.innerHTML = 'Hay <b>' + n + ' cubiertas</b> para tu ' + esc(modelName()) + '.';
      } else if (model === 'otra') {
        out.textContent = 'Escríbenos con tu modelo y año, y la buscamos para tu pickup.';
      } else {
        out.textContent = 'Te mostramos solo las que calzan con tu pickup.';
      }
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var tab = t.closest && t.closest('[data-tab]');
      var chip = t.closest && t.closest('[data-f]');
      var link = t.closest && t.closest('[data-filter]');
      var clear = t.closest && t.closest('[data-clear-model]');
      if (chip) setFilter(chip.getAttribute('data-f'));
      if (link) setFilter(link.getAttribute('data-filter'));
      if (clear) {
        model = ''; sel.value = ''; store.set(STORE_KEY, '');
        updateFinder(); render();
      }
      if (tab) showType(tab.getAttribute('data-tab'));
    });

    if (sel) {
      sel.value = model;
      sel.addEventListener('change', function () {
        model = sel.value; store.set(STORE_KEY, model);
        updateFinder(); render();
      });
    }
    updateFinder(); render();

    /* WhatsApp */
    var waText = function () {
      return 'Hola ATLAS, quiero una cubierta para mi pickup.' +
        (model && model !== 'otra' ? '\nMi pickup: ' + modelName() : '') + '\nAño: ';
    };
    all('[data-wa]').forEach(function (a) {
      var setHref = function () { a.href = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(waText()); };
      setHref();
      a.addEventListener('click', setHref);
    });

    /* Reveal, dock */
    var reveals = all('.reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15 });
      reveals.forEach(function (el) { io.observe(el); });
    }
    if (dock && prodSec) {
      var tk = false;
      window.addEventListener('scroll', function () {
        if (tk) return; tk = true;
        requestAnimationFrame(function () {
          var r = prodSec.getBoundingClientRect();
          dock.classList.toggle('show', window.scrollY > window.innerHeight * 0.9 && !(r.top < window.innerHeight && r.bottom > 0));
          tk = false;
        });
      }, { passive: true });
    }
  }

  document.querySelectorAll('[data-atlas-cubiertas]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
